module.exports = __webpack_public_path__ + "static/media/Group237659.745723dd.webp";